export const downloadFile = async (url, filename) => {
    try {
        const res = await fetch(url);
        if (!res.ok) throw new Error("Error descargando archivo");

        const blob = await res.blob();
        const link = document.createElement("a");

        link.href = window.URL.createObjectURL(blob);
        link.download = filename;

        document.body.appendChild(link);
        link.click();

        link.remove();
        window.URL.revokeObjectURL(link.href);
    } catch (err) {
        console.error("Download error:", err);
    }
};
